export default {
  isPreloader: false,
  reports: [],
  reportTemplate: {},
  isDisabledSendReportBtn: true,
  errors: {
    getReports: '',
    getReportTemplate: '',
    validation: [],
    controls: null,
    calculateReport: '',
    submitReport: '',
    draftReport: '',
    getReportList: '',
    getStatistic: ''
  },
  reportName: '',
  loading: false,
  statisticLoading: false,
  isShowLogoutModal: false,
  reportList: [],
  statisticValues: [],
  calculateReportLoading: false,
  loadingSendReport: false
}



// WEBPACK FOOTER //
// ./src/store/modules/reporting/state.js